import { Box, IconButton, Tooltip, useTheme, Typography, useMediaQuery, Container } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import { ColorModeContext, tokens } from "../../Theme/theme";
import { Logout, PeopleAltRounded } from "@mui/icons-material";
import AdminList from "../AdminRoles/AdminList";
import { Link, useNavigate } from "react-router-dom";
import '../../assets/fonts/fonts.css'
import searchIcon from '../../assets/search.svg'
import BASE_URL from "../../NetworkConfig/ApiConfig";
const Topbar = ({ data, onClick }) => {
  const navigate = useNavigate();

  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')

  const handlelogout = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [searchedUsers, setSearchedUsers] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false)
  const searchRef = useRef(null);


  useEffect(() => {
    if (!searchQuery || searchQuery.length < 2) {
      setSearchedUsers([]);
      setShowDropdown(false);
      return;
    }

    const timer = setTimeout(async () => {
      searchUsers(searchQuery)
      setSearchLoading(false);
    }, 300); // debounce

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    const close = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);


  const searchUsers = async (q) => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/user/s-u?q=${q}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    const data = await response.json();
    console.log(data)
    if (data.success === true) {
      setSearchedUsers(data.data ?? [])
      setShowDropdown(true)
    } else {
      setShowDropdown(false)
      alert(data.response)
    }
  };


  return (

    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        marginLeft: isMobileScreen || isTabScreen ? "0px" : "300px",
        background: "#0b0b0f",
        borderBottom: "1px solid #aaaaaa10",
      }}
    >
      <Container maxWidth={false} disableGutters>

        <Box sx={{ flexDirection: "column", display: "flex" }} >
          <Box display="flex" justifyContent="space-between" px={2} py={2}>



            {/* SEARCH */}
            <Box display="flex" alignItems="center" ref={searchRef} position="relative">

              {(isMobileScreen || isTabScreen) && (
                <Box onClick={onClick} sx={{
                  width: 40, height: 40, background: "#ffffff10", borderRadius: "10px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "1px solid #ffffff10", mr: 2, cursor: "pointer"
                }}>
                  <MenuRoundedIcon />
                </Box>
              )}

              {!(isMobileScreen || isTabScreen) && (
                <Box sx={{
                  display: "flex", alignItems: "center", borderRadius: "15px",
                  background: "#ffffff10", border: "1px solid #ffffff15"
                }}>
                  <img src={searchIcon} width={20} height={20} style={{ marginLeft: 15, filter: "invert(1)" }} />

                  <input
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search user..."
                    style={{
                      background: "transparent",
                      border: 0,
                      outline: 0,
                      color: "#fff",
                      width: 420,
                      padding: "12px 15px",
                      fontFamily: "poppins-reg",
                      fontSize: 15
                    }}
                  />
                </Box>
              )}

              {/* FLOATING SEARCH DROPDOWN */}
              {showDropdown && !isMobileScreen && !isTabScreen && (
                <Box sx={{
                  position: "absolute",
                  top: "110%",
                  left: 0,
                  width: "100%",
                  maxHeight: 320,
                  overflowY: "auto",
                  background: "#0b0b0f",
                  border: "1px solid #ffffff20",
                  borderRadius: "14px",
                  boxShadow: "0 20px 60px #00000090",
                  zIndex: 9999,
                  backdropFilter: "blur(12px)"
                }}>

                  {searchLoading ? (
                    <Typography p={2} color="#aaa">Searching...</Typography>
                  ) : searchUsers.length === 0 ? (
                    <Typography p={2} color="#aaa">No users found</Typography>
                  ) : (
                    searchedUsers.map((u) => (
                      <Box key={u._id}
                        onClick={() => {
                          setSearchedUsers([])
                          setSearchQuery("")
                          setShowDropdown(false)
                          navigate(`/admin/particularuserdetails?userid=${u._id}`)
                        }}
                        sx={{
                          display: "flex", alignItems: "center", gap: 2,
                          px: 2, py: 1.5, cursor: "pointer",
                          borderBottom: "1px solid #ffffff10",
                          "&:hover": { background: "#ffffff08" }
                        }}>
                        <Box sx={{ width: 36, height: 36, borderRadius: "50%", overflow: "hidden" }}>
                          <img src={u.image[0]} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        </Box>
                        <Box>
                          <Typography color="#fff" fontSize={14} fontFamily={'poppins-reg'} >{u.full_name}</Typography>
                          <Typography color="#aaa" fontSize={11} fontFamily={'poppins-reg'} >{u.buzz_name}</Typography>
                        </Box>
                      </Box>
                    ))
                  )}
                </Box>
              )}
            </Box>

            {/* RIGHT SIDE */}
            <Box display="flex" alignItems="center">
              {(isMobileScreen || isTabScreen) && (
                <Box
                  onClick={() => {
                    setShowSearchBar(!showSearchBar)
                  }}
                  sx={{
                    width: '50px', height: "50px",
                    background: '#ffffff10', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    border: '1px solid #ffffff10', borderRadius: '15px',
                    marginRight: '20px'
                  }}>
                  <img alt="search_icon" width="20px" height="20px"
                    style={{
                      objectFit: 'contain', filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                      alignSelf: 'center', marginRight: '3px', marginBottom: '2px'
                    }}
                    src={searchIcon} />
                </Box>
              )}

              {data.Role === "ADMIN" && (
                <Tooltip title="Manage Team">
                  <Box component={Link} to="/admin/adminlist"
                    sx={{
                      width: 50, height: 50, background: "#ffffff10",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      borderRadius: "15px"
                    }}>
                    <PeopleAltRounded sx={{ color: "#fff" }} />
                  </Box>
                </Tooltip>
              )}

              <Box onClick={() => navigate("/admin/profile")}
                sx={{
                  display: "flex", alignItems: "center",
                  borderLeft: "2px solid #aaaaaa20", ml: 2, pl: 2, cursor: "pointer"
                }}>
                <Box sx={{ width: 40, height: 40, borderRadius: "50%", overflow: "hidden", background: "#ffffff20" }}>
                  <img src={data.Photo || "/profile_place_holder.png"} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </Box>
                {!(isMobileScreen || isTabScreen) && (
                  <Box ml={1} mr={"5px"}>
                    <Typography fontSize={"14px"} mb={"-2px"} color={"#ffffff"} fontFamily={"poppins-reg"} >{data.UserName ?? ""}</Typography>
                    <Typography m={0} p={0} fontSize={"10px"} color={"#aaaaaa"} fontFamily={"poppins-reg"} >{data.Role ? data.Role.charAt(0).toUpperCase() + data.Role.slice(1).toLowerCase() : "Team"}</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          {
            showSearchBar && (isMobileScreen || isTabScreen) && (
              <Box display="flex" sx={{ marginInline: "15px", marginBottom: "10px", display: "flex", flexDirection: "row" }} alignItems="center" ref={searchRef} position="relative">



                {(isMobileScreen || isTabScreen) && (
                  <Box sx={{
                    display: "flex", alignItems: "center", borderRadius: "15px",
                    background: "#ffffff10", border: "1px solid #ffffff15",
                    flexDirection: "row", flex: 1
                  }}>
                    <img src={searchIcon} width={20} height={20} style={{ marginLeft: 15, filter: "invert(1)" }} />

                    <input
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Search user..."
                      style={{
                        background: "transparent",
                        border: 0,
                        display: "flex",
                        flex: 1,
                        outline: 0,
                        color: "#fff",
                        padding: "12px 15px",
                        fontFamily: "poppins-reg",
                        fontSize: 15
                      }}
                    />
                  </Box>
                )}

                {/* FLOATING SEARCH DROPDOWN */}
                {showDropdown && (isMobileScreen || isTabScreen) && (
                  <Box sx={{
                    position: "absolute",
                    top: "110%",
                    left: 0,
                    width: "100%",
                    maxHeight: 320,
                    overflowY: "auto",
                    background: "#0b0b0f",
                    border: "1px solid #ffffff20",
                    borderRadius: "14px",
                    boxShadow: "0 20px 60px #00000090",
                    zIndex: 9999,
                    backdropFilter: "blur(12px)"
                  }}>

                    {searchLoading ? (
                      <Typography p={2} color="#aaa">Searching...</Typography>
                    ) : searchUsers.length === 0 ? (
                      <Typography p={2} color="#aaa">No users found</Typography>
                    ) : (
                      searchedUsers.map((u) => (
                        <Box key={u._id}
                          onClick={() => {
                            setSearchedUsers([])
                            setSearchQuery("")
                            setShowDropdown(false)
                            setShowSearchBar(false)
                            navigate(`/admin/particularuserdetails?userid=${u._id}`)
                          }}
                          sx={{
                            display: "flex", alignItems: "center", gap: 2,
                            px: 2, py: 1.5, cursor: "pointer",
                            borderBottom: "1px solid #ffffff10",
                            "&:hover": { background: "#ffffff08" }
                          }}>
                          <Box sx={{ width: 36, height: 36, borderRadius: "50%", overflow: "hidden" }}>
                            <img src={u.image[0]} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          </Box>
                          <Box>
                            <Typography color="#fff" fontSize={14} fontFamily={'poppins-reg'} >{u.full_name}</Typography>
                            <Typography color="#aaa" fontSize={11} fontFamily={'poppins-reg'} >{u.buzz_name}</Typography>
                          </Box>
                        </Box>
                      ))
                    )}
                  </Box>
                )}
              </Box>
            )
          }
        </Box>
      </Container>
    </Box>
  );
};

export default Topbar;
